import MainStore from '../stores/MainStore.js';

export const initialize = () => {
  parse();
};

export const getThumbnailURL = (url) => {
    if( url===null ) return "";
    if( url.indexOf(".jpg")>-1 ) url = url.replace(".jpg","_320x.jpg");
    else if( url.indexOf(".png")>-1 ) url = url.replace(".png","_320x.png");
    else if( url.indexOf(".jpeg")>-1 ) url = url.replace(".jpeg","_320x.jpeg");
    return url;
};



export const getConfig = (item) =>{
  if( !window.__config_reactjs_cart.products_config || !window.__config_reactjs_cart.products_config.hasOwnProperty(item.product_id) ) return null;
  return window.__config_reactjs_cart.products_config[item.product_id];
}

export const getStep = (item) =>{
  let product_config = getConfig(item);
  if( !product_config ) return 1;
  //if( !window.__config_reactjs_cart.products_config || !window.__config_reactjs_cart.products_config.hasOwnProperty(item.product_id) ) return 1;
  //let product_config = window.__config_reactjs_cart.products_config[item.product_id];
  //console.log(product_config);
  if( typeof product_config["discounts"] !== "undefined" ){
    let tmp = item["options_with_values"][2]["value"];
    //console.log(tmp);
    if( typeof product_config["discounts"][tmp] !== "undefined"){
      //console.log(product_config["discounts"][tmp]["step"]);
      return product_config["discounts"][tmp]["step"];
    }
  }
  return 1;
}

export const addedQuantity = (id) => {
    for( let key in MainStore.added_products ){
        let product = MainStore.added_products[key];
        if( product.id===id ) return product.quantity;
    }
    return 0;
};

export const itemTotal = (item,discount) => {
  let label = propertyLabelValue(item);
  let price = item.price;
  //console.log(item);
  //let total_rate = 0;

  //console.log(discount);
  if( discount.eligible  ){
    price = discount.price;
  }
  //console.log(price);

  //console.log( discount.un_labeled_rate );
  //10% for un labeled
  if( label.toLowerCase()==="no label" && discount.un_labeled_rate > 0 ){
    price -= (item.price/100)*discount.un_labeled_rate;
  }
  //console.log( price );
  return price *100 * item.quantity;
}
/*
export const itemTotal = (item,discount) => {
  let label = propertyLabelValue(item);
  let price = item.price;
  //let single_price = price;
  //console.log(item);
  //console.log(discount);

  let total_rate = 0;

  if( discount.eligible  ){
    total_rate += discount.rate;
  }

  //10% for un labeled
  if( label.toLowerCase()==="no label" && discount.un_labeled_rate > 0 ){
    //single_price *= (100 - discount.un_labeled_rate*100)/100;
    total_rate += discount.un_labeled_rate;
  }
  let single_price = price * (100 - total_rate*100)/100;
  //console.log(single_price);

  return single_price * item.quantity;
}
*/

export const propertyLabelValue = (item) => {
  let value = null;
  //console.log(item);
  for(let key in item.properties){
    let property_value = item.properties[key];
    if( key==="label" ) value = property_value;
  }
  return value;
}

export const getProductByVariantID = (id) => {
    for( let key in window.__products ){
        let product = window.__products[key];
        for( let key_variant in product.variants ){
            let variant = product.variants[key_variant];
            if( variant["id"]===id ) return product;
        }
    }
    return null;
};

//Get product
export const get = (id) => {
  //console.log( window.__config_reactjs_cart?.products );
  //if( typeof window.__cart_items_products[id] !== "undefined" ) return window.__cart_items_products[id];
  if( window.__config_reactjs_cart?.products && typeof window.__config_reactjs_cart.products[id] !== "undefined" ) return window.__config_reactjs_cart.products[id];
  return null;
};

export const getVariantByVariantID = (vid,pid=null) => {
  if( pid!==null){
    if( typeof window.__config_reactjs_cart.products[pid] === "undefined" ) return null;
    let product = window.__config_reactjs_cart.products[pid];
    //console.log(product);
    for( let key_variant in product.variants.edges ){
      let variant = product.variants.edges[key_variant].node;
      //console.log(variant);
      if( variant.id.replace("gid://shopify/ProductVariant/","")===vid.toString() ) return variant;
    }
  }
  else{
    for( let key in window.__config_reactjs_cart.products ){
      let product = window.__config_reactjs_cart.products[key];
      for( let key_variant in product.variants ){
        let variant = product.variants[key_variant];
        if( variant["id"]===vid ) return variant;
      }
    }
  }
  return null;
};

export const getProductByHandle = (handle) => {
    for( let key in window.__products ){
        let product = window.__products[key];
        if( product.handle === handle ) return product;
    }
    return null;
};

export const _productRemove = (item) =>{
    //let step = item.step;
    //MainStore.added_products[step] = {};
    let new_products = [];
    for( let key in MainStore.added_products ){
        let product = MainStore.added_products[key];
        if( product.id!==item.id ) new_products.push(product);
    }
    
    MainStore.added_products = new_products;

    MainStore._cartChange();
};

export const _productIncrease = (item) =>{
    let found = false;
    for( let key in MainStore.added_products ){
        let product = MainStore.added_products[key];
        if( product.id===item.id ){
            product.quantity++;
            MainStore.added_products[key] = product;
            found = true;
            break;
        }
    }
    if( !found ){
        MainStore.added_products.push({
            id: item.id,
            quantity: 1
        });
    }

    MainStore._cartChange();
};

export const _productDecrease = (item) =>{
    for( let key in MainStore.added_products ){
        let product = MainStore.added_products[key];
        if( product.id===item.id ){
            product.quantity--;
            MainStore.added_products[key] = product;
            break;
        }
    }

    let new_products = [];
    for( let key in MainStore.added_products ){
        let product = MainStore.added_products[key];
        if( product.quantity > 0 ) new_products.push(product);
    }
    MainStore.added_products = new_products;

    MainStore._cartChange();
};

const parse = () => {
    MainStore.showing_products["step1"] = [];
    MainStore.showing_products["step2"] = [];
    MainStore.showing_products["step3"] = [];
    MainStore.showing_products["step4"] = [];
    MainStore.showing_products["step5"] = [];
    for( let key in window.__products ){
        let product = window.__products[key];
        if( product.tags.includes("wax warmers") && !product.title.toLowerCase().includes('kit') ){
            MainStore.showing_products["step1"].push(product);
        }
        if( product.tags.includes("wax") ){
            MainStore.showing_products["step2"].push(product);
        }
        if( product.tags.includes("pre and post products") ){
            //Care products
            MainStore.showing_products["step3"].push(product);
        }
        if( product.tags.includes("Retail") ){
            MainStore.showing_products["step4"].push(product);
        }
        if( product.tags.includes("accessories") ){
            MainStore.showing_products["step5"].push(product);
        }
    }

    for( let key in MainStore.showing_products["step1"] ){
        let product = MainStore.showing_products["step1"][key];
        //Object.defineProperty(product.metas.bundler_app,'index',{value:3});
        //product.metas.bundler_app["index"] = 3;
        if( typeof product.metas.bundler_app !== "undefined" ){
            if( product.metas.bundler_app.title === "Small" ) product.metas.bundler_app.sort_index = 3;
            else if( product.metas.bundler_app.title === "Double" ) product.metas.bundler_app.sort_index = 2;
            else if( product.metas.bundler_app.title === "Large" ) product.metas.bundler_app.sort_index = 1;
            else product.metas.bundler_app.sort_index = 0;
        }
        else{
            product.metas.bundler_app = { sort_index: 0 };
        }

        MainStore.showing_products["step1"][key] = product;
    }

    //Remove Hide products
    for( let key_step in MainStore.showing_products ){
        let new_products = [];
        for( let key in MainStore.showing_products[key_step] ){
            let product = MainStore.showing_products[key_step][key];
            if( typeof product.metas.bundler_app !== "undefined" && product.metas.bundler_app.hide === "1" ){
                continue;
            }
            new_products.push(product);
        }
        MainStore.showing_products[key_step] = new_products;
    }


    //Add default sort index
    for( let key_step in MainStore.showing_products ){
        for( let key in MainStore.showing_products[key_step] ){
            let product = MainStore.showing_products[key_step][key];
            if( typeof product.metas.bundler_app === "undefined" || product.metas.bundler_app.sort_index === "" ){
                product.metas.bundler_app = { sort_index: 0 };
                MainStore.showing_products[key_step][key] = product;
            }
        }
    }

    //Sorting
    for( let key_step in MainStore.showing_products ){
        MainStore.showing_products[key_step].sort(sortIndexCompare);
    }
};

const sortIndexCompare = (a, b) =>{
    if( a.metas.bundler_app.sort_index < b.metas.bundler_app.sort_index ) return 1;
    else if( a.metas.bundler_app.sort_index > b.metas.bundler_app.sort_index ) return -1;
    else return 0
};